export default __webpack_public_path__ + "static/media/omakuva_small.e7e9b334.png";